import { AnyAction } from 'redux';

let tefComs: HTMLElement;

const service = {
  bindTefComs: (wc: HTMLElement) => {
    tefComs = wc;
  },

  logInfo: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.info(`tef-coms: ${args.map((arg) => `${<string>arg}`).join(', ')}`);
  },

  logError(...args: unknown[]) {
    // eslint-disable-next-line no-console
    console.error(`tef-coms: ${args.map((arg) => `${<string>arg}`).join(', ')}`);
  },

  fireEvent: (name: string, details = {}) => {
    const event = new CustomEvent('tef-coms', {
      bubbles: true,
      composed: true, // pass through shadow DOM boundaries
      detail: {
        name,
        ...details,
      },
    });
    tefComs.dispatchEvent(event);
  },

  fireError: (name: string, details = {}) => {
    service.fireEvent(name, { level: 'error', ...details });
  },

  fireInfo: (name: string, details = {}) => {
    service.fireEvent(name, { level: 'info', ...details });
  },

  scrollToTop: () => {
    tefComs.scrollIntoView({ behavior: 'smooth' });
  },

  tracker: {
    reduxActionListener: (action: AnyAction) => {},
    // eslint-disable-next-line no-unused-vars
    doTracking: (name: string, data = {}) => {},
  },
} as const;

export default service;
